module.exports = __webpack_public_path__ + "img/img_aboutus_goal_teachers@2x.fdd580ea.png";